import {MainRequest} from 'Services/common';
import {Key} from 'react';

const UrlMap = {
    list: '/aichat/agent/dataset',
    options: '/aichat/agent/dataset/not',
    edit: '/aichat/agent/dataset/saves',
    remove: '/aichat/agent/dataset/deletes',
};
export class AgentDataSet {
    static list(params: AgentDataSet.QueryList) {
        return MainRequest.get<SuccessData<AgentDataSet.List[]>>(
            `${UrlMap.list}/${params?.agentId}`,
            {
                params,
            },
        ).then(res => res.data.data);
    }
    static options(params: AgentDataSet.QueryList) {
        return MainRequest.get<SuccessData<AgentDataSet.List[]>>(
            `${UrlMap.options}/${params?.agentId}`,
            {
                params,
            },
        ).then(res => res.data.data);
    }

    static async save({agentId, data}: AgentDataSet.Save) {
        return MainRequest.post(`${UrlMap.edit}/${agentId}`, data);
    }

    static async remove({agentId, ids}: AgentDataSet.Remove) {
        return MainRequest.post(`${UrlMap.remove}/${agentId}`, ids);
    }
}

export namespace AgentDataSet {
    export type QueryForm = {};

    export interface Schema {
        code: string; //        数据集编码，唯一标识
        name: string; //        数据集名称
        description: string; //        数据集描述
        externalId: string; //        RAGFlow中的数据集ID
        config: object; //        数据集配置（JSON格式）
        status: boolean; //        状态：0-禁用，1-启用
        priority: number; //优先级
        enabled: boolean; //是否启用
    }

    export interface List extends Schema {
        id: string;
        updatedAt: string;
        createdAt: string;
    }

    export interface Form extends Schema {
        id?: string;
    }

    export interface Save {
        agentId: string;
        data: Form[];
    }

    export interface Remove {
        agentId: string;
        ids: Key[];
    }

    export type QueryList = QueryForm & {agentId: string};
}
